import React from "react";

import { NoteActivity } from "../../../api/services";
import { useTruncate } from "../../../hooks";
import { NoteIcon } from "../../../icons";
import { ActivityListItem } from "./ActivityListItem";
import { useRouteMatch } from "react-router-dom";
import { ActivitySummaryCell } from "./ActivitySummaryCell";
import { ActivityTitle } from "./ActivityTitle";

export const NoteActivityItem: React.FC<{
  activity: NoteActivity;
}> = ({ activity }) => {
  const { id, activityDttm, summary, subject } = activity;
  const { url } = useRouteMatch();
  const link = `${url}/notes/${id}`;
  return (
    <ActivityListItem
      icon={<NoteIcon width={16} height={16} />}
      title={
        <ActivityTitle>
          {subject}
          {useTruncate(summary, 120)}
        </ActivityTitle>
      }
      activityDttm={activityDttm}
      linkTo={link}
    />
  );
};

export const NoteActivitySummaryCell: React.FC<{
  activity: NoteActivity;
  isGrey: boolean;
}> = ({ activity, isGrey }) => {
  const { summary, subject } = activity;
  return (
    <ActivitySummaryCell
      isGrey={isGrey}
      icon={<NoteIcon width={16} height={16} />}
      summary={`${subject}: ${useTruncate(summary, 120)}`}
    />
  );
};
